<template>
    <div class="styleInstance">
        <div class="top disflex">
            <div class="imgBox"><img :src="data.logo" alt="" /></div>
            <div class="cent-box">
                <div>{{ data.name || '专场名称' }}</div>
                <div class="tips">{{ data.desc || '专场描述专场描述专场描述专场描述专场描述' }}</div>
            </div>

            <el-button class="butCol" size="mini">{{ data.facade_widget.entry_button.text || '进入专场' }}</el-button>
        </div>

        <div class="cover">
            <img :src="data.thumbs[0]" alt="" />
        </div>

        <div class="items">
            <div class="item">
                <div class="imgPriceBox"></div>
                <div class="price">
                    <span>{{ data.facade_widget.product_price.text || '秒杀价' }}</span>
                    <span class="price-text">￥11.9</span>
                </div>
            </div>
            <div class="item">
                <div class="imgPriceBox"></div>
                <div class="price">
                    <span>{{ data.facade_widget.product_price.text || '秒杀价' }}</span>
                    <span class="price-text">￥11.9</span>
                </div>
            </div>
            <div class="item">
                <div class="imgPriceBox"></div>
                <div class="price">
                    <span>{{ data.facade_widget.product_price.text || '秒杀价' }}</span>
                    <span class="price-text">￥11.9</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.styleInstance {
    border: 1px solid #ccc;
    padding: 10px;
    width: max-content;
    width: 400px;

    .disflex {
        display: flex;
        align-items: center;
    }

    .imgBox {
        width: 44px;
        height: 44px;
        border: 1px solid #ccc;
        border-radius: 10px;
        background: #ccc;
        padding: 5px;
        & > img {
            width: 100%;
            height: 100%;
        }
    }

    .tips {
        width: 100%;
        overflow: hidden; /* 隐藏超出元素宽度的内容 */
        text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
        white-space: nowrap; /* 规定文本不换行，强制在一行内显示 */
    }

    .cent-box {
        line-height: 1.4;
        margin: 0 20px;
        flex: 1;
        width: 0;
    }

    .butCol {
        color: #fff;
        background: #db231f;
    }

    .cover {
        width: 100%;
        height: 160px;
        border-radius: 10px;
        margin-top: 10px;
        overflow: hidden;
        background: #ccc;
        & > img {
            width: 100%;
            height: 100%;
        }
    }

    .items {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .item {
            flex: 0 0 26%;
            line-height: 1.4;
            .imgPriceBox {
                width: 100%;
                height: 100px;
                margin-bottom: 10px;
                border-radius: 10px;
                background: #ccc;
            }

            .price {
                font-size: 12px;
                .price-text {
                    color: #db231f;
                    font-size: 16px;
                }
            }
        }
    }
}
</style>